import React from 'react';
import { Diamond } from 'lucide-react';
import { ethers } from 'ethers';

const RoyaltyMetrics = ({ totalEarned, available, poolSize, onClaim, canClaim }) => {
  // Function to format values from wei to USDT with 18 decimals
  const formatFromWei = (value) => {
    try {
      // First convert to a BigNumber if it's not already
      let bnValue;
      if (typeof value === 'string' || typeof value === 'number') {
        bnValue = ethers.BigNumber.from(value.toString());
      } else {
        bnValue = value; // Assume it's already a BigNumber
      }
      
      // Convert from wei to USDT (18 decimals)
      const formatted = ethers.utils.formatUnits(bnValue, 18);
      
      // Return formatted with 2 decimal places
      return `${parseFloat(formatted).toFixed(2)} USDT`;
    } catch (error) {
      console.error("Error formatting wei value:", error);
      return "0.00 USDT";
    }
  };

  return (
    <>
      <div className="royalty-metrics">
        <div className="royalty-metric">
          <div className="metric-value">{formatFromWei(totalEarned)}</div>
          <div className="metric-label">Total Earned</div>
        </div>
        <div className="royalty-metric">
          <div className="metric-value">{formatFromWei(available)}</div>
          <div className="metric-label">Available to Claim</div>
        </div>
        <div className="royalty-metric">
          <div className="metric-value">{formatFromWei(poolSize)}</div>
          <div className="metric-label">Current Pool Size</div>
        </div>
      </div>
      
      <div className="royalty-claim-container">
        <button 
          className="claim-btn" 
          disabled={!canClaim}
          onClick={onClaim}
        >
          <span className="btn-text">Claim Royalty Rewards</span>
          <span className="btn-icon"><Diamond size={16} /></span>
        </button>
      </div>
    </>
  );
};

export default RoyaltyMetrics;